export const MESSAGES_REQUEST = '@api/MESSAGES_REQUEST'
export const MESSAGES_SUCCESS = '@api/MESSAGES_SUCCESS'
export const MESSAGES_ERROR = '@api/MESSAGES_ERROR'
